import { Instance } from 'mobx-state-tree'
import { PlayerCallEntityModelBase } from './PlayerCallEntityModel.base'

/* The TypeScript type of an instance of PlayerCallEntityModel */
export interface PlayerCallEntityModelType extends Instance<typeof PlayerCallEntityModel.Type> {}

/* A graphql query fragment builders for PlayerCallEntityModel */
export {
  selectFromPlayerCallEntity,
  playerCallEntityModelPrimitives,
  PlayerCallEntityModelSelector
} from './PlayerCallEntityModel.base'

/**
 * PlayerCallEntityModel
 */
export const PlayerCallEntityModel = PlayerCallEntityModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
